// src/components/AuthGuard.jsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function AuthGuard({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // whenever the URL changes...
    if (
      location.pathname === "/biodata" &&
      !localStorage.getItem("email")
    ) {
      // kick them back to login, replacing history
      navigate("/applicant-login", { replace: true });
    }
  }, [location, navigate]);

  return children;
}
